__turbopack_context__.v({
  "policy_togglebtn_wrapper": "_0sxh-G_policy_togglebtn_wrapper",
  "toggle_btn": "_0sxh-G_toggle_btn",
});
